import { render, staticRenderFns } from "./commoditieslist.vue?vue&type=template&id=4e1c5eac"
import script from "./commoditieslist.vue?vue&type=script&lang=js"
export * from "./commoditieslist.vue?vue&type=script&lang=js"
import style0 from "./commoditieslist.vue?vue&type=style&index=0&id=4e1c5eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports